import { Box, Portal, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import theme from '../../muiTheme';
import Notifications from '../Notifications/Notifications';
import UserAvatar from '../UserAvatar/UserAvatar';

const DynamicUI = () => {

    //notifications are obtained from redux store and displayed for about 5 seconds each

    const {showNotifications, showProfileMenu, showCreatePost, showUserPrompt} = useSelector((state) => state.dynamicUIReducer);



    return (

        <>

            {
                (
                    showNotifications 
                    || showProfileMenu 
                    || showCreatePost 
                    || showUserPrompt
                ) &&
                    <Portal>


                    

                        {
                        
                            showNotifications &&
                        
                            <Notifications />
                        
                        }
                        

                </Portal>

            }

        </>
        
    ); 
}

export default DynamicUI; 